import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import { Button } from '@mantine/core';

export const DistributionRuleSupportButton = ({ children }: { children?: React.ReactNode }) => {
	return (
		<Button variant="white" size="sm" component="a" href="mailto:support@dealstack.io">
			<TextV2 variant="sans/14/600">{children}</TextV2>
		</Button>
	);
};
